/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { AuthContext } from 'context/AuthContext';

import DestaquesCultura from './components/DestaquesCultura';
import './styles.scss';

export default function Destaque() {
  const { realCycle, user } = useContext(AuthContext);

  const [hiddenHead, setHiddenHead] = useState(false);
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);
  const [activeCycle, setActiveCycle] = useState<any>(null);

  useEffect(() => {
    if (!realCycle) return;
    const cycleOptions = realCycle.map((cycle: any) => {
      cycle.label = 'Ciclo ' + cycle.title;
      cycle.value = cycle._id;
      return cycle;
    });
    setOptionsCycle(cycleOptions);
  }, [realCycle]);

  return (
    <RebrandShell title="Destaques" subtitle="Os reconhecimentos e as dimensões que se destacaram no ciclo.">
      {!hiddenHead && optionsCycle.length > 0 && (
        <div className="rb-destaque-toolbar">
          <h2 className="rb-destaque-toolbar__label">Reconhecimentos recebidos pelos participantes</h2>
          <select
            className="rb-input rb-destaque-toolbar__select"
            value={activeCycle?.value || ''}
            onChange={e => setActiveCycle(optionsCycle.find((c: any) => c.value === e.target.value) || null)}
            aria-label="Selecionar ciclo"
          >
            <option value="">Todos os ciclos</option>
            {optionsCycle.map((cycle: any) => (
              <option key={cycle.value} value={cycle.value}>
                {cycle.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <DestaquesCultura showHead={(e: boolean) => setHiddenHead(e)} options={activeCycle} />

      <Outlet />
    </RebrandShell>
  );
}
